import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MemoryService {

  private agentLaunchCheck = new BehaviorSubject(false);
  private urlHistory = new BehaviorSubject([]);
  private allProjects = new BehaviorSubject([]);
  private selectedProject = new BehaviorSubject(null);
  private currentUser = new BehaviorSubject(null);
  private breadCrumbObj = new BehaviorSubject([]);
  private copyTestStep = new BehaviorSubject([])
  private cutTestStep = new BehaviorSubject([])
  private setSourceID = new BehaviorSubject(null);
  private groupedActionData = new BehaviorSubject([]);
  private actionsObj= new BehaviorSubject([]);
  private functionsObj =  new BehaviorSubject([]);
  constructor() { }

  resetSubjects()
  {
    this.urlHistory.next([]);
    this.allProjects.next([]);
    this.selectedProject.next([]);
    this.currentUser.next([]);
    this.breadCrumbObj.next([]);
  }

  setAgentCheck(flag){
    this.agentLaunchCheck.next(flag);
  }
   
  getAgentCheck(){
    return this.agentLaunchCheck.asObservable();
  }

  setUrlHistory(value)
  {
    this.urlHistory.next(value);
  }

  getUrlHistory()
  {
    return this.urlHistory.asObservable();
  }
  
  setAllProjectsData(value)
  {
    this.allProjects.next(value);
  }

  getAllProjectsData()
  {
    return this.allProjects.asObservable();
  }

  setSelectedProject(value)
  {
    this.selectedProject.next(value);
  }

  getSelectedProject()
  {
    return this.selectedProject.asObservable();
  }

  setCurrentUser(value)
  {
    this.currentUser.next(value);
  }

  getCurrentUser()
  {
    return this.currentUser.asObservable();
  }

  setBreadCrumb(breadcrumb){
  this.breadCrumbObj.next(breadcrumb)
  }

  getBreadCrumb(){
   return this.breadCrumbObj.asObservable();
    }
  //copyTestStep
  setCopiedObj(value) {
    this.copyTestStep.next(value)
  }
  getCopiedObj() {
    return this.copyTestStep.asObservable();
  }
  setCutObj(value) {
    this.cutTestStep.next(value)
  }
  getCutObj() {
    return this.cutTestStep.asObservable();
  }
  setSourceId(value) {
    this.setSourceID.next(value)
  }
  getSourceId() {
    return this.setSourceID.asObservable();
  }
  setGroupedActionData(value){
    this.groupedActionData.next(value)
  }
  getGroupedActionData(){
   return this.groupedActionData.asObservable()
  }
  setActions(value){
    this.actionsObj.next(value);
  }
  getActions(){
   return this.actionsObj.asObservable();
  }
  setFunctions(value){
    this.functionsObj.next(value);
  }
  getFunctions(){
   return this.functionsObj.asObservable();
  }
  }
  


